import _ from "underscore";
import * as config from "../config";
import {Align} from "./align";
import uuid from 'uuid/v1'

export class CreateObject {
    constructor(db, scene, group, texture) {
        this.db = db;
        this.scene = scene;
        this.group = group;
        this.texture = texture;
        this.scene.objectUpdate[texture] = new Date();
        this.scene.objectUpdate[texture].setMilliseconds(this.scene.objectUpdate[texture].getMilliseconds() + 500);
    }

    generate() {
        let date = new Date();
        if (_.isEmpty(this.db) || date >= this.db.timeToNew) {
            date.setSeconds(date.getSeconds() + 5);
            this.db.timeToNew = date;
            let item = this.scene.physics.add.sprite(
                Phaser.Math.Between(0, config.width),
                Phaser.Math.Between(0, 400),
                this.texture
            );
            Align.scaleToGameW(item, .05);
            let id = uuid();
            item.id = id;
            item.isHitted = false;
            this.db.items.push({
                item,
                hp: config.projectile[this.texture].hp,
                id
            })
            this.group.add(item)
            item.setBounce(Phaser.Math.Between(1, 3),Phaser.Math.Between(1, 3))
                .setGravityY(100)
                .setMaxVelocity(300, 300)
        }
    }

    gravityChange() {
        let date = new Date();
        if (date >= this.scene.objectUpdate[this.texture] && this.db.items.length > 0) {
            this.scene.objectUpdate[this.texture].setMilliseconds(date.getMilliseconds() + 500);
            _.each(this.db.items, (element) => {
                element.item.setGravityX(Phaser.Math.Between(-200, 200))
            })
        }
    }

}
